import React from 'react';
import { InboxIcon } from 'lucide-react';

export function EmptyState({ title, message, icon: Icon = InboxIcon, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <Icon className="w-16 h-16 text-gray-300 dark:text-gray-600 mb-4" />
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">{title}</h3>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-6 max-w-sm">{message}</p>
      {action && (
        <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm font-medium">
          {action}
        </button>
      )}
    </div>
  );
}
